import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import Multiselect from "@/components/multiselect/multiselect";
import ChangeProduct from "@/components/subscriptions/subscriptionsChangeProduct/subscriptionsChangeProduct";
import { localCurrency } from "@/plugins/currency";
import Loading from "@/components/loading/loading";

@Component({
  components: {
    Multiselect,
    ChangeProduct,
    Loading
  }
})
export default class MenuConfiguration extends Vue {

  // Actions
  @Action action_updateSubscription;

  // Getters
  @Getter getCurrentMenu;
  @Getter getCurrentMenuOption;
  @Getter getCurrentDay;
  @Getter getMenuOptions;
  @Getter getCity;
  @Getter getAllMenuItemProducts;
  @Getter getSubscription;

  // Mutations
  @Mutation CURRENT_MENU_OPTION;
  @Mutation CURRENT_MENU;
  @Mutation CURRENT_SUBSCRIPTION_MENU;

  isLoading = false;
  currentSubscriptionMenu = null;
  detailsSubscriptionMenus = [];
  menuAllInfo = null;
  selectedMenuOption = null;
  selectedItems = null;

  // Attributes for product change
  currentItem = {
    item: null,
    index: null,
    menuItem: null
  };
  isChangingProduct = false;

  get getAvailableMenuOptions() {
    let response = [];
    if (
      this.getCurrentMenu &&
      this.getCurrentMenu.menu_options
    ) {
      response = [...this.getCurrentMenu.menu_options];
    }
    return response;
  }

  get menuNameSimple() {
    return this.getCurrentMenu.name.replace(/.$/,"");
  }
  
  mounted() {
    this.isChangingProduct = false;
    this.currentItem = null;
    this.selectedMenuOption = {...this.getCurrentMenuOption};
    this.selectedItems = [...this.getCurrentDay.items];
  }

  private getDefaultItems(menuOption) {
    let response = [];
    if (
      menuOption &&
      menuOption.menu_items &&
      menuOption.menu_items.length &&
      menuOption.menu_item_ids &&
      menuOption.menu_item_ids.length
    ) {
      menuOption.menu_item_ids.forEach((itemId) => {
        let itemObj: any = {};
        const find = menuOption.menu_items.find((item) => item.id === itemId);
        if (
          find &&
          find.is_active &&
          find.name &&
          find.products_details &&
          find.products_details.length &&
          find.products_details[0]
        ) {
          itemObj = {
            ...find.products_details[0],
            menu_items_product_id: find.products_details[0].id
          };
          response.push({ ...itemObj });
        }
      });
    }
    return response;
  }

  getMenuOptionById(menuOptionId) {
    let response = null;
    if (
      this.getCurrentMenu &&
      this.getCurrentMenu.menu_options &&
      this.getCurrentMenu.menu_options.length
    ) {
      response = this.getCurrentMenu.menu_options.find(
        (menuOption) => menuOption.id === menuOptionId
      );
    }
    return response;
  }

  _setMenuOption(menuOption) {
    if(this.selectedMenuOption.id !== menuOption.id) {
      this.selectedMenuOption = menuOption;
      this.selectedItems = this.getDefaultItems(menuOption);
    }
  }

  _onGoBack() {
    this.$router.replace({ name: "subscriptions_openWeek" });
  }

  _changeMenuItem(item, index) {
    const fullItem = this.getMenuItemProductById(item.menu_items_product_id);
    this.currentItem = {
      item,
      index: index,
      menuItem: this.getMenuItemById(fullItem.menu_item_id)
    };
    this.isChangingProduct = true;
  }

  _onChangeProduct(product) {
    if (this.currentItem && this.currentItem.index >= 0) {
      this.selectedItems[this.currentItem.index] = {
        ...product,
        menu_items_product_id: product.id
      };
    }
    this.currentItem = {
      index: null,
      item: null,
      menuItem: null
    };
    this.isChangingProduct = false;
  }

  _onCloseChangeProduct() {
    this.isChangingProduct = false;
  }

  async _onSaveChanges() {
    await this._onSubmitChanges();
    this.$router.go(-1);
  }

  private getMenuItemById(menuItemId) {
    let response = null;
    if (
      this.selectedMenuOption &&
      this.selectedMenuOption.menu_items &&
      this.selectedMenuOption.menu_items.length
    ) {
      response = this.selectedMenuOption.menu_items.find((menuItem)=> menuItem.id === menuItemId);
    }
    return response;
  }

  getMenuItemProductById(itemsProductId) {
    return this.getAllMenuItemProducts.find((itemProduct) => itemProduct.id === itemsProductId);
  }

  getMenuItemType(itemsProductId) {
    let response = "";
    const menuItemProduct = this.getMenuItemProductById(itemsProductId);
    if (menuItemProduct && menuItemProduct.menu_item_id) {
      const menuItem = this.getMenuItemById(menuItemProduct.menu_item_id);
      response = menuItem.name;
    }
    return response;
  }

  getMenuOptionInfo() {
    return this.menuAllInfo.menu_options.find(
      (menuOption) => menuOption.id === this.getCurrentMenuOption.menu_option_id
    );
  }

  _money(value) {
    return localCurrency(value);
  }

  async _onSubmitChanges() {
    this.isLoading = true;
    let tempObject = null;
    let tempDetailsSubscriptionMenus = [...this.getSubscription.details_subscription_menus];
    const menuFindIndex = tempDetailsSubscriptionMenus.findIndex((menu) => menu.menu_id === this.getCurrentMenu.id);
    if(menuFindIndex !== -1) {
      const dayFindIndex = tempDetailsSubscriptionMenus[menuFindIndex].day.findIndex(
        (day) => day.count_id === this.getCurrentDay.count_id
      );
      if(dayFindIndex !== -1) {
        tempDetailsSubscriptionMenus[menuFindIndex].day[dayFindIndex].items = this.selectedItems;
        tempDetailsSubscriptionMenus[menuFindIndex].day[dayFindIndex].menu_option_id = this.selectedMenuOption.id;
      }
    }
    try {
      let payload = {
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        subscription: null
      };
      const itemsToDelete = this.emptySubscriptionMenus();
      const subscriptionsMenusArray = this.subscriptionMenuDetailsToIdsArray(
        tempDetailsSubscriptionMenus
      );
      tempObject = { subscription_menus_attributes: [...itemsToDelete, ...subscriptionsMenusArray] };
      payload.subscription = { subscription: tempObject};
      await this.emptySubscriptionMenus();
      await this.action_updateSubscription(payload);
    } catch (error) {
      this._showErrorMessage(error);
      this.isLoading = false;
    }
  }

  subscriptionMenuDetailsToIdsArray(detailsSubscriptionMenus) {
    let response = [];
    const subscriptionMenus = [...detailsSubscriptionMenus];
    if(subscriptionMenus && subscriptionMenus.length) {
      subscriptionMenus.map((menu) => {
        if(menu && menu.menu_id) {
          menu.day.map((day) => {
            if(day.menu_option_id && day.count_id >= 0) {
              day.items.map((item) => {
                if(item.menu_items_product_id) {
                  response.push({
                    subscription_id: this.getSubscription.id,
                    menu_id: menu.menu_id,
                    menu_option_id: day.menu_option_id,
                    count_id: day.count_id,
                    menu_items_product_id: item.menu_items_product_id
                  });
                }
              });
            }
          });
        }
      });
    }
    return response;
  }

  emptySubscriptionMenus() {
    const subscription_menus_attributes = this.getSubscription.subscription_menus.map((item) => {
      return { id: item.id, _destroy: 1 };
    });
    return subscription_menus_attributes;
  }

  _showErrorMessage(error) {
    let msg = "";
    if(error && error.response && error.response.data && error.response.data.message) {
      msg = error.response.data.message;
    }
    this.$swal({
      title: "Error",
      text: "Error enviando la solicitud. " + msg
    });
  }
}
